export default __webpack_public_path__ + "static/media/logo.3ba5e327.svg";